import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import Product from './Product';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, getProducts } from '../../redux/actions/productAction';
import Loader from '../common/Loader';
import { toast } from 'react-hot-toast';

const FeaturedProducts = () => {
    const dispatch = useDispatch();
    const { loading, products, error } = useSelector((state) => state.products);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        dispatch(getProducts());
    }, [dispatch, error]);

    return loading ? (
        <Loader />
    ) : (
        <div id='featuredProducts' className='section-padding-top section-padding-bottom'>
            <Container>
                <SectionHeading heading={'Featured products'} />
                <div className='productsSection'>
                    {products &&
                        products.map((product, i) => <Product key={i} product={product} />)}
                </div>
            </Container>
        </div>
    );
};

export default FeaturedProducts;
